import React, {  Fragment, PureComponent } from 'react'
import { AdministrationLogoutStatus } from './AdministrationLogoutconstants';
import AdministrationLogout from "./AdministrationLogout"
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import Loading from '../../Utils/Loading';

export class AdministrationLogoutView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: true
    }

  }
 
  closeSnackBar = () => {
    this.setState({
      open: false
    })

  }
  static getDerivedStateFromProps(props, state) {
    if(props.AdministrationLogout_status == AdministrationLogoutStatus.AdministrationLogout.SUCCESS)
    {
        props.cookies.remove('admin_token_customer', { path: '/' });
        props.cookies.remove('njt_admin_userId_customer', { path: '/' });
        props.history.replace({
         pathname:"/"
       })

    } 
     return null;
  }
  
  getScreen(status) {
    switch (status) {
      case AdministrationLogoutStatus.AdministrationLogout.NEW:
        return (
          <Fragment >
            <AdministrationLogout
             AdministrationLogout={this.props.AdministrationLogout} 
            className={this.props.className}
            cookies={this.props.cookies}
            />
          </Fragment>
        );


      case AdministrationLogoutStatus.AdministrationLogout.SUCCESS:
         // alert(JSON.stringify(this.props.AdministrationLogout))
        
        return (
          <Fragment >
            <AdministrationLogout
             cookies={this.props.cookies}
            AdministrationLogout={this.props.AdministrationLogout} 
            className={this.props.className}
            />
          </Fragment>
        );
        break;
      case AdministrationLogoutStatus.AdministrationLogout.FAILED:
        // alert(this.props.AdministrationLogout_Error)
        toast.error(this.props.AdministrationLogout_Error)
        return (
          <Fragment>
            
            <AdministrationLogout 
             cookies={this.props.cookies}
            AdministrationLogout={this.props.AdministrationLogout} 
            className={this.props.className}
            />

          </Fragment>
        );

      case AdministrationLogoutStatus.AdministrationLogout.LOADING:
        return (
          <div className="admin-loading">
            <Loading/>
          </div>
        );
        break;
      default:
        return <div />
    }

  }
  render() {
   // alert(this.props.AdministrationLogout_status)
    return (
      this.getScreen(this.props.AdministrationLogout_status)
    )
  }
}

export default withRouter(AdministrationLogoutView)
